import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import Layouts from './layouts/layout';
import styles from './css/SuccessTopupContest.module.css';

// ===================== TEXT (0 = English, 3 = Portuguese) =====================
const successText = {
    "0": {
        back: "Back to home",
        title: "Top-up successful!",
        textStart: "You have unlocked",
        textBold: "20 more questions",
        textEnd: "in the QuizMaster contest.",
        stepsTitle: "What you get",
        step1: "20 extra questions to play right now",
        step2: "Every correct answer adds stars to your score",
        step3: "Climb the leaderboard and win money on M-Pesa",
        note: "Keep playing to boost your chances of winning up to 20,000 MT!",
        play: "Play 20 more questions",
        leaderboard: "See leaderboard",
        home: "Back to home",
    },
    "3": {
        back: "Voltar ao início",
        title: "Recarga feita com sucesso!",
        textStart: "Desbloqueaste",
        textBold: "mais 20 perguntas",
        textEnd: "no concurso QuizMaster.",
        stepsTitle: "O que ganhaste",
        step1: "20 perguntas extra para jogar agora mesmo",
        step2: "Cada resposta certa soma estrelas à tua pontuação",
        step3: "Sobe na classificação e ganha dinheiro no M-Pesa",
        note: "Continua a jogar para aumentar as tuas hipóteses de ganhar até 20.000 MT!",
        play: "Jogar mais 20 perguntas",
        leaderboard: "Ver classificação",
        home: "Voltar ao início",
    },
};

const SuccessTopupContest = () => {
    const navigate = useNavigate();
    const language = localStorage.getItem('selectedLanguage');
    const text = successText[language] || successText["0"];

    return (
        <Layouts>
            <div className={styles.page}>

                {/* HEADER WITH BACK ARROW */}
                <div className={styles.header}>
                    <button type="button" className={styles.backButton} onClick={() => navigate('/home')} aria-label={text.back}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="15 18 9 12 15 6" />
                        </svg>
                    </button>
                </div>

                {/* SUCCESS CARD */}
                <div className={styles.card}>
                    <div className={styles.icon}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                    </div>
                    <h2 className={styles.title}>{text.title}</h2>
                    <p className={styles.text}>
                        {text.textStart} <strong>{text.textBold}</strong> {text.textEnd}
                    </p>

                    {/* WHAT YOU GET */}
                    <div className={styles.steps}>
                        <p className={styles.stepsTitle}>{text.stepsTitle}</p>
                        <div className={styles.step}>
                            <span className={styles.stepNumber}>1</span>
                            <span>🎯 {text.step1}</span>
                        </div>
                        <div className={styles.step}>
                            <span className={styles.stepNumber}>2</span>
                            <span>⭐ {text.step2}</span>
                        </div>
                        <div className={styles.step}>
                            <span className={styles.stepNumber}>3</span>
                            <span>🏆 {text.step3}</span>
                        </div>
                    </div>

                    <p className={styles.note}>{text.note}</p>

                    <NavLink to="/promo/quiz" className={styles.primaryButton}>{text.play}</NavLink>
                    <button type="button" className={styles.secondaryButton} onClick={() => navigate('/home')}>
                        {text.home}
                    </button>
                </div>

            </div>
        </Layouts>
    )
}

export default SuccessTopupContest